/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_TipInputs */

const en_pc_tut_tip = /** @type {(inputs: Pc_Tut_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip`)
};

const zh_pc_tut_tip = /** @type {(inputs: Pc_Tut_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示`)
};

/**
* | output |
* | --- |
* | "Tip" |
*
* @param {Pc_Tut_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_tip = /** @type {((inputs?: Pc_Tut_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_tip(inputs)
	return zh_pc_tut_tip(inputs)
});
export { pc_tut_tip as "pc.tut.tip" }